
import { Image } from 'react-bootstrap';
import { GET_MEDIA_NAME, getImageSize, HANDLE_IMAGE_ERROR } from '../../../utils';
import { useEffect, useRef, useState } from 'react';


const ImageType = ({ mediaClass, size, height, width, url, alt, isProduct, handleAllImageError, item, isCover }) => {


  const [padding, setPadding] = useState(size ? size : 100)
  const fallbackTried = useRef(false)

  const onMediaLoad = async () => {
    if (size) {
      setPadding(size)
    } else {
      if (height && height != "" && width && width != "") {
        setPadding((height * 100) / width)
      } else {
        try {
          const { width, height } = await getImageSize(url);
          setPadding((height * 100) / width)
        } catch (error) {
          setPadding(100)
        }
      }
    }
  }


  useEffect(() => {
    onMediaLoad()
  }, [size])

  // Reset the fallback attempt whenever the primary url changes
  useEffect(() => {
    fallbackTried.current = false
  }, [url])

  const handleError = (event) => {
    // 1st failure: retry once with item.file before falling back to the error image
    const fallbackUrl = item?.file;
    if (!fallbackTried.current && fallbackUrl && fallbackUrl !== url) {
      fallbackTried.current = true
      event.target.src = fallbackUrl
      return
    }
    HANDLE_IMAGE_ERROR(event, isProduct, handleAllImageError);
  };


  return <div className={`${mediaClass} overflow-hidden position-relative`} style={{ paddingBottom: `${padding}%` }}>
    <Image className={`position-absolute  h-100 w-100 object-center-${isCover ? 'cover' : 'contain'}`} loading="lazy" src={url} height={height} width={width} data-load="0" data-id={item?.id} data-network={item?.networkId} alt={alt != '' ? alt : GET_MEDIA_NAME(url)} onError={handleError} fluid />
  </div>
}
export default ImageType